import * as Yup from "yup";

// const vehicleNumberPattern = /^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/;
const vehicleNumberPattern = /^[A-Z]{2}[0-9]{2}[A-Z]{1,2}[0-9]{4}$/;
const gstFormateRegex =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

const mobileFormateRehex = /^[6-9]\d{9}$/;
const panFormateRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
const panNumberPattern = /^[A-Z]{3}[PCFHAT][A-Z][0-9]{4}[A-Z]$/;
const licenseNumberRegex = /^[A-Z]{2}[0-9]{2}[0-9]{7}$/; ///^[A-Z]{2}\d{2}[A-Z]-\d{4}-\d{7}$/
const fssaiFormatRegex = /^[0-9]{14}$/;
const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^[6-9]\d{9}$/;
const pinCodeRegex = /^[1-9][0-9]{5}$/;

function checkBalance(balance) {
  if (balance > 0) {
    return "plus";   // Positive balance
  } else if (balance < 0) {
    return "minus";  // Negative balance
  } else {
    return "zero";   // Exactly 0
  }
}

export const errorSchema = {
  createParty: Yup.object().shape({
    name: Yup.string().trim().required("This filed is Required"),
    as_of_date: Yup.string().required("This filed is Required"),
    gst_treatment_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // gst_state: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    consignor_group_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    template_no: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    gst_no: Yup.string().when("gst_treatment_id", {
      is: (value) => value?.value != 1, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // GST number is not required when value is 1
    }),
    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email format. Example: example@domain.com")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }),
    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
  }),
  createUnit: Yup.object().shape({
    name: Yup.string().required("This filed is Required"),
    contact_no: Yup.string()
      .min(10, "Required")
      .required("This filed is Required"),
    gst_treatment_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // gst_state: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    consignor_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    zone_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    gst_no: Yup.string().when("gst_treatment_id", {
      is: (value) => value?.value != 1, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // GST number is not required when value is 1
    }),
    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email format. Example: example@domain.com")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }),
    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
    city: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
  }),

  addProfileModalSchema: Yup.object().shape({
    full_name: Yup.string().required("Full Name is Required"),
    city: Yup.object().shape({
      name: Yup.string().required("City is required"),
    }),
    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email format. Example: example@domain.com")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }),
  }),

  addCompanyModalSchema: Yup.object().shape({
    company: Yup.string().required("Business Name is Required"),
    entity_type: Yup.string().required("Entity Type is Required"),
    contact_no: Yup.string().required("Contact Number is Required"),
    is_gst: Yup.boolean(),
    gst_no: Yup.string().when("is_gst", {
      is: (test) => test === true, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // Ensures the GST number length is 15
    }),
    city: Yup.object({
      label: Yup.string().required("city is required"),
    }),
  }),

  addCompanyModalSchema: Yup.object().shape({
    company: Yup.string().required("Business Name is Required"),
    entity_type: Yup.string().required("Entity Type is Required"),
    contact_no: Yup.string().required("Contact Number is Required"),
    is_gst: Yup.boolean(),
    gst_no: Yup.string().when("is_gst", {
      is: (test) => test === true, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // Ensures the GST number length is 15
    }),
    city: Yup.object({
      label: Yup.string().required("city is required"),
    }),
  }),

  updateCompanyModalSchema: Yup.object().shape({
    company: Yup.string().required("Business Name is Required"),
    entity_type: Yup.string().required("Entity Type is Required"),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
    gst_no: Yup.string()
      .nullable()
      .test("valid-gst", "Invalid GST format", (value) => {
        if (!value) return true; // Skip validation if empty
        return gstFormateRegex.test(value) && value.length === 15;
      }),
    city: Yup.object({
      label: Yup.string().required("city is required"),
    }),
    email_id: Yup.string()
      .nullable()
      .notRequired()
      .test("valid-email", "Invalid email format. Example: example@domain.com", (value) => {
        if (!value) return true; // Skip if empty

        // Full email regex — covers all cases
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!emailRegex.test(value)) return false; // Basic format check

        // TLD should not contain numbers
        const domain = value.split("@")[1];
        if (!domain) return false;

        const tld = domain.split(".").pop();
        if (/\d/.test(tld)) return false; // TLD mein digits nahi hone chahiye

        return true;
      }),
    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
    pan_no: Yup.string()
      .nullable()
      .test("valid-pan", "Invalid PAN format", (value) => {
        if (!value) return true;
        return panFormateRegex.test(value) && value.length === 10;
      }),

    fssai_licence: Yup.string()
      .nullable()
      .test("valid-fssai", "Invalid FSSAI license number", (value) => {
        if (!value) return true;
        return fssaiFormatRegex.test(value) && value.length === 14;
      }),
    website: Yup.string()
      .nullable()
      .test("valid-url", "Invalid website URL", (value) => {
        if (!value) return true;
        try {
          new URL(value); // This ensures it's a valid URL
          return true;
        } catch {
          return false;
        }
      }),
  }),

  addUserSchema: Yup.object().shape({
    company_user_name: Yup.string().required("Name is Required"),
    // mobileno: Yup.string()
    //   .required("Mobile No is Required")
    //   .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
    mobileno: Yup.string()
      .required("Mobile No is Required")
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
    email_id: Yup.string()
      .email("Invalid email address")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }),
    role_id: Yup.string().required("Role is Required"),
    language: Yup.string().required("This filed is Required"),
    company_id: Yup.string().required("This filed is Required"),
    consignor_group_id: Yup.string().required(" Consignor Group is Required"),
    vehicle_group_id: Yup.string().required(" Vehicle Group is Required"),

    // branch_list:Yup.array()
    // .required('Array is required')
  }),

  addSupplierSchema: Yup.object().shape({
    name: Yup.string().trim().required("This filed is Required"),
    as_of_date: Yup.string().required("This filed is Required"),
    gst_treatment_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // gst_state: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    gst_no: Yup.string().when("gst_treatment_id", {
      is: (value) => value?.value != 1, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // GST number is not required when value is 1
      // otherwise: Yup.string().nullable(),
    }),
    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email format. Example: example@domain.com")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }),
    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
    pan_no: Yup.string().when(["pan_mandatory", "pan_validation"], {
      is: (pan_mandatory, pan_validation) =>
        !!pan_mandatory || !!pan_validation,
      then: (schema) =>
        schema
          .required("PAN number is required")
          .matches(
            /^[A-Z]{5}[0-9]{4}[A-Z]$/,
            "Invalid PAN number format."
          ),
      otherwise: (schema) =>
        schema.test("is-valid-pan", "Invalid PAN number format.", (value) => {
          if (!value) return true;
          return /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value.toUpperCase());
        }),
    }),
    pan_image: Yup.string().when("pan_attach_mandatory", {
      is: true,
      then: (schema) => schema.required("PAN image is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),

  createBranch: Yup.object().shape({
    branch: Yup.string().trim().required("This filed is Required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    gst_treatment_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // gst_state: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    gst_no: Yup.string().when("gst_treatment_id", {
      is: (value) => value?.value != 1, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // GST number is not required when value is 1
    }),
    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email format. Example: example@domain.com")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }),
    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
  }),

  createConsignee: Yup.object().shape({
    name: Yup.string().required("This filed is Required"),
    gst_treatment_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // gst_state: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    zone_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email format. Example: example@domain.com")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }),
    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
  }),
  createMarketDriverSchema: Yup.object().shape({
    name: Yup.string().required("This filed is Required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // without permission licence_number
    // licence_number: Yup.string()
    //   .nullable()
    //   .notRequired()
    //   .test(
    //     "is-valid-license-number",
    //     "Enter a valid license number, e.g. MP09N-2020-1234567 or MP09-2020-1234567",
    //     function (value) {
    //       if (!value) return true; // Skip validation if empty
    //       return /^[A-Z]{2}\d{2}[A-Z]?-?\d{4}-\d{7}$/.test(value);
    //     }
    //   ),

    // without permission aadhar_no
    // aadhar_no: Yup.string()
    //   .nullable()
    //   .notRequired() // Field is optional
    //   .test(
    //     "is-valid-aadhar",
    //     "Aadhar number must be exactly 12 digits",
    //     (value) => {
    //       if (!value) return true; // Skip validation if field is empty
    //       return /^\d{12}$/.test(value); // Only valid if exactly 12 digits
    //     }
    //   ),

    aadhar_no: Yup.string().when("aadhar_no_mandatory", {
      is: true, // ✅ when true
      then: (schema) =>
        schema
          .required("Aadhar number is required")
          .matches(/^\d{12}$/, "Aadhar number must be exactly 12 digits"),

      otherwise: (schema) =>
        schema.nullable().notRequired(), // ✅ no validation
    }),
    licence_number: Yup.string().when("license_no_mandatory", {
      is: true,
      then: (schema) =>
        schema
          .required("License number is required")
          .matches(
            /^[A-Z]{2}\d{2}[A-Z]?-?\d{4}-\d{7}$/,
            "Enter a valid license number, e.g. MP09N-2020-1234567 or MP09-2020-1234567"
          ),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
  }),
  createOwnDriverSchema: Yup.object().shape({
    name: Yup.string().trim().required("This filed is Required"),
    as_of_date: Yup.string().required("This filed is Required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // without permission licence_number
    // licence_number: Yup.string()
    //   .nullable()
    //   .notRequired()
    //   .test(
    //     "is-valid-license-number",
    //     "Enter a valid license number, e.g. MP09N-2020-1234567 or MP09-2020-1234567",
    //     function (value) {
    //       if (!value) return true; // Skip validation if empty
    //       return /^[A-Z]{2}\d{2}[A-Z]?-?\d{4}-\d{7}$/.test(value);
    //     }
    //   ),

    // without permission aadhar_no
    // aadhar_no: Yup.string()
    //   .nullable()
    //   .notRequired() // Field is optional
    //   .test(
    //     "is-valid-aadhar",
    //     "Aadhar number must be exactly 12 digits",
    //     (value) => {
    //       if (!value) return true; // Skip validation if field is empty
    //       return /^\d{12}$/.test(value); // Only valid if exactly 12 digits
    //     }
    //   ),

    aadhar_no: Yup.string().when("aadhar_no_mandatory", {
      is: true, // ✅ when true
      then: (schema) =>
        schema
          .required("Aadhar number is required")
          .matches(/^\d{12}$/, "Aadhar number must be exactly 12 digits"),

      otherwise: (schema) =>
        schema.nullable().notRequired(), // ✅ no validation
    }),
    licence_number: Yup.string().when("license_no_mandatory", {
      is: true,
      then: (schema) =>
        schema
          .required("License number is required")
          .matches(
            /^[A-Z]{2}\d{2}[A-Z]?-?\d{4}-\d{7}$/,
            "Enter a valid license number, e.g. MP09N-2020-1234567 or MP09-2020-1234567"
          ),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
  }),

  createVehicleSchema: Yup.object().shape({
    vehicle_no: Yup.string()
      .matches(
        /^[A-Z]{2}\s?\d{1,2}\s?[A-Z]{0,2}\s?\d{4}$/i,
        "Please enter a valid vehicle number (e.g., KA01AB1234 or KA 63 6714)"
      )
      .required("This field is required"),
    vehicle_type_id_1: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    vehicle_group: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    manage_fuel: Yup.boolean(),
    vehicle_average: Yup.string().when("manage_fuel", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    opening_fuel: Yup.string().when("manage_fuel", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    fuel_amount: Yup.string().when("manage_fuel", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
  createLrModalSchema: Yup.object().shape({
    party: Yup.object().shape({
      label: Yup.string().required("Party name is required"),
    }),
  }),
  createBankExport: Yup.object().shape({
    bank: Yup.string().required("This filed is Required"),
  }),
  createTripSchima: Yup.object().shape({
    branch_id: Yup.string().required("This filed is Required"),
    vehicle_id: Yup.string().required("This filed is Required"),

    supplier_id: Yup.string().when("ownership", {
      is: (ownership) => ownership === 2,
      then: () => Yup.string().required("Supplier name is required"),
    }),
    start_kms: Yup.string().when("manage_trip_kms", {
      is: (manage_trip_kms) => manage_trip_kms === 1,
      then: () => Yup.string().required("This filed is Required"),
      otherwise: () => Yup.string().notRequired(), // This ensures start_kms is not required when manage_trip_kms is not 1
    }),
    driver_id: Yup.string().when(["ownership", "marketDriverMandatory"], {
      is: (ownership, marketDriverMandatory) =>
        ownership === 1 ||
        ownership === 3 ||
        (ownership === 2 && marketDriverMandatory === 1),
      then: () => Yup.string().required("Driver is required"),
      otherwise: () => Yup.string().nullable(),
    }),

    dispatch_date: Yup.string().required("This filed is Required"),
    vehicle_type_id: Yup.string().required("This filed is Required"),
    toLoction: Yup.array().of(
      Yup.object().shape({
        to_city: Yup.string().required("This filed is Required"),
      })
    ),
    fromLoction: Yup.array().of(
      Yup.object().shape({
        from_city: Yup.string().required("This filed is Required"),
      })
    ),
    // amount: Yup.string().when(["branchMandetry", "ownership", "freight_type", "firmFreight"], {
    //   is: (branchMandetry, ownership, freight_type) =>
    //     branchMandetry === 1 && ownership === 2 && freight_type === 6,
    //   then: () => Yup.string().required("Total freight is required"),
    //   otherwise: () => Yup.string().notRequired(),
    // }),
    // amount: Yup.string().when(
    //   ["firmFreight", "branchMandetry", "ownership", "freight_type"],
    //   {
    //     is: (firmFreight, branchMandetry, ownership, freight_type) => {
    //       const condition1 =
    //         firmFreight === true &&
    //         Number(branchMandetry) === 1 &&
    //         Number(ownership) !== 2;

    //       const condition2 =
    //         Number(branchMandetry) === 1 &&
    //         Number(ownership) === 2 &&
    //         Number(freight_type) === 6;

    //       console.log("Amount required:", condition1 , condition2,firmFreight,branchMandetry,ownership);

    //       return condition1 || condition2;
    //     },
    //     then: () => Yup.string().required("Total freight is required"),
    //     otherwise: () => Yup.string().notRequired(),
    //   }
    // ),

    amount: Yup.string().when(
      ["firmFreight", "branchMandetry", "ownership", "freight_type"],
      {
        is: (firmFreight, branchMandetry, ownership, freight_type) => {
          const condition1 =
            firmFreight === true &&
            Number(branchMandetry) === 1 &&
            Number(ownership) !== 2;

          const condition2 =
            Number(branchMandetry) === 1 &&
            Number(ownership) === 2 &&
            Number(freight_type) === 6;

          return condition1 || condition2;
        },

        then: () =>
          Yup.string()
            .required("Total freight is required")
            .test("not-zero", "Total freight must be required", (value) => {
              if (value === undefined || value === null || value === "") return false;
              return Number(value) > 0;  // ❌ 0 block ho jayega
            }),

        otherwise: () => Yup.string().notRequired(),
      }
    ),

    rate: Yup.string().when(["branchMandetry", "ownership", "freight_type"], {
      is: (branchMandetry, ownership, freight_type) =>
        branchMandetry === 1 && ownership === 2 && freight_type !== 6,
      then: () => Yup.string().required("Rate is required"),
      otherwise: () => Yup.string().notRequired(),
    }),

    qty: Yup.string().when(["branchMandetry", "ownership", "freight_type"], {
      is: (branchMandetry, ownership, freight_type) =>
        branchMandetry === 1 && ownership === 2 && freight_type !== 6,
      then: () => Yup.string().required("Quantity is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    // LoadingChalli validation
    loadingChalli: Yup.array().when("loadingChalliMandatory", {
      is: (loadingChalliMandatory) => loadingChalliMandatory === 1,
      then: () =>
        Yup.array().test(
          "loading-challi-required",
          "At least one loading challi input is required",
          function (value) {
            if (!value || !Array.isArray(value)) return false;

            // Check first 20 values (excluding total at index 20)
            const inputs = value.slice(0, 20);
            return inputs.some(
              (input) => input && input.toString().trim() !== ""
            );
          }
        ),
      otherwise: () => Yup.array().notRequired(),
    }),
    // firm_Freight : Yup.string().when("firmFreight", {
    //   is: (test) => test === true,
    //   then: (schema) => schema.required("This field is Required"),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
  }),
  addEditLrModalSchema: Yup.object().shape({
    invoice_date: Yup.string().required("This filed is Required"),
    from_location: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    to_location: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    branch_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
  }),

  addRouteValidation: Yup.object().shape({
    from_location: Yup.array().of(
      Yup.object().shape({
        from_city: Yup.string().required("Pickup Location is required"),
        from_state: Yup.string().required("Location required"),
        lat: Yup.string().required("Location required"),
        long: Yup.string().required("Location required").nullable(),
      })
    ),

    to_location: Yup.array().of(
      Yup.object().shape({
        to_city: Yup.string().required("Drop Location is required"),
        to_state: Yup.string().required("Location required"),
        lat: Yup.string().required("Location required"),
        long: Yup.string()
          .required("Location required")
          .required("email required")
          .nullable(),
      })
    ),
    route_name: Yup.string().required("Route name is Required"),
    route_code: Yup.string().required("Route code is Required"),
  }),

  addNewLrSeriesModalSchema: Yup.object().shape({
    prefix: Yup.string().required("Prefix is Required"),
    next_number: Yup.string().required("Next number is Required"),
  }),
  selectUnitLrModalSchema: Yup.object().shape({
    unit_id: Yup.object().shape({
      label: Yup.string().required(" Unit address is Required"),
    }),
  }),
  addItemInLrSchema: Yup.object().shape(
    {
      name: Yup.string().required("This filed is Required"),
      // material_code: Yup.string().required("Required"),
      // hsn_code: Yup.string().required("Required"),
      material_category_id: Yup.object().shape({
        label: Yup.string().required("This filed is Required"),
      }),
      qty_type: Yup.object().shape({
        label: Yup.string().required("This filed is Required"),
      }),
      weight: Yup.string().when("weight", {
        is: (exist) => exist,
        then: () =>
          Yup.string()
            .min(1)
            .max(8)
            .matches(
              /^\d+(\.\d{1,2})?$/,
              "Only numbers with up to two decimal places are allowed"
            )
            .required("Required"),
      }),
    },
    [["weight", "weight"]]
  ),
  addItemGroupInLrSchema: Yup.object().shape({
    name: Yup.string().required("This filed is Required"),
    // hsn_code: Yup.string().required("Required"),
  }),
  addPartyPointSchema: Yup.object().shape({
    date: Yup.string().required("This filed is Required"),
    // notes: Yup.string().required("Required"),
  }),
  addPodReceviedSchema: Yup.object().shape({
    date: Yup.string().required("This filed is Required"),
    file: Yup.array()
      .of(
        Yup.object().shape({
          path: Yup.string().required("This filed is Required"),
        })
      )
      .min(1, "At least 1 Attachement Required"),
  }),
  addTotalFreigthSchema: Yup.object().shape({
    freight_type: Yup.number().required("Freight type is required"),

    amount: Yup.number()
      .transform((value, originalValue) => (originalValue === "" ? undefined : value))
      .when("freight_type", {
        is: 6,
        then: (schema) =>
          schema
            .required("Amount is required")
            .moreThan(0, "Amount must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),

    qty: Yup.number()
      .transform((value, originalValue) => (originalValue === "" ? undefined : value))
      .when("freight_type", {
        is: (val) => val !== 6,
        then: (schema) =>
          schema
            .required("Quantity is required")
            .moreThan(0, "Quantity must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),

    rate: Yup.number()
      .transform((value, originalValue) => (originalValue === "" ? undefined : value))
      .when("freight_type", {
        is: (val) => val !== 6,
        then: (schema) =>
          schema
            .required("Rate is required")
            .moreThan(0, "Rate must be greater than 0"),
        otherwise: (schema) => schema.notRequired(),
      }),
  }),

  // addFreigthSchema: Yup.object().shape({
  //   sub_category: Yup.string().required("This filed is Required"),
  //   balance: Yup.number()
  //     .required("Balance is required")
  //     .positive("Balance must be a positive number"),
  //   amount: Yup.number()
  //     .required("Amount is required")
  //     .positive("Amount must be a positive number")
  //     .transform((value, originalValue) => {
  //       if (originalValue === "") {
  //         return null;
  //       }
  //       return value;
  //     })
  //     .when("balance", (balance, schema) =>
  //       schema.test({
  //         test: function (value) {
  //           return value <= balance;
  //         },
  //         message: "Amount must not be greater than balance",
  //       })
  //     ),
  //   txn_date: Yup.string().required("This filed is Required"),

  //   account_sub_category: Yup.string().required("This filed is Required"),
  //   account_id: Yup.string().required("This filed is Required"),
  //   isCheck: Yup.boolean(),
  //   vendor_account: Yup.string().when("isCheck", {
  //     is: (test) => test === true,
  //     then: () => Yup.string().required("This filed is Required"),
  //     // otherwise: Yup.string(),
  //   }),
  // }),


  addFreigthSchema: Yup.object().shape({
    sub_category: Yup.string().required("This field is Required"),

    balance: Yup.number()
      .required("Balance is required"),
    // .positive("Balance must be a positive number"),

    amount: Yup.number()
      .transform((value, originalValue) => {
        if (originalValue === "") return null;
        return value;
      })
      .when(["sub_category", "balance"], {
        is: (sub_category, balance) =>
          sub_category == 2 && (balance === 0 || checkBalance(balance) === "minus"),
        then: (schema) => schema.notRequired(), // skip validation
        otherwise: (schema) =>
          schema
            .required("Amount is required")
            .positive("Amount must be a positive number")
            .test("amount-less-than-balance", "Amount must not be greater than balance", function (value) {
              const { balance } = this.parent;
              return value <= balance;
            }),
      }),

    txn_date: Yup.string().required("This field is Required"),

    account_sub_category: Yup.string().required("This field is Required"),
    account_id: Yup.string().required("This field is Required"),
    isCheck: Yup.boolean(),

    vendor_account: Yup.string().when("isCheck", {
      is: true,
      then: () => Yup.string().required("This field is Required"),
    }),
  }),

  addChargeSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),
    balance: Yup.number()
      .required("Balance is required")
      .positive("Balance must be a positive number"),
    amount: Yup.number()
      .required("Amount is required")
      .positive("Amount must be a positive number")
      .transform((value, originalValue) => {
        if (originalValue === "") {
          return null;
        }
        return value;
      })
      .when("balance", (balance, schema) =>
        schema.test({
          test: function (value) {
            return value <= balance;
          },
          message: "Amount must not be greater than balance",
        })
      ),
    // amount: Yup.string()
    //   .required("Amount is required")
    //   .test(
    //     "is-greater-than-zero",
    //     "Amount must be greater than zero",
    //     (value) => {
    //       const num = parseFloat(value);
    //       return !isNaN(num) && num > 0;
    //     }
    //   ),
    txn_date: Yup.string().required("This filed is Required"),
    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "11",
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    isCheck: Yup.boolean(),
    vendor_account: Yup.string().when("isCheck", {
      is: (test) => test === true,
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
  }),
  addChargeCompleteSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),

    amount: Yup.number()
      .required("Amount is required")
      .positive("Amount must be a positive number"),

    txn_date: Yup.string().required("This filed is Required"),
    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "11",
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    isCheck: Yup.boolean(),
    vendor_account: Yup.string().when("isCheck", {
      is: (test) => test === true,
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
  }),
  addAccountSchema: Yup.object().shape({

    account_type: Yup.number().required("Account type is required"),
    // Account number - only required for Bank Account (type 1)
    account_number: Yup.string().when("account_type", {
      is: (value) => value === 1,
      then: (schema) =>
        schema
          .required("Account Number is required")
          .matches(/^[0-9]+$/, "Account number must contain only digits")
          .min(9, "Account number must be at least 9 digits")
          .max(18, "Account number must not exceed 18 digits")
      ,
      otherwise: (schema) => schema.notRequired(),
    }),
    confirm_account_number: Yup.string().oneOf(
      [Yup.ref("account_number"), null],
      "Account numbers must match"
    ),
    // .required("Please confirm your account number"),


    // bank_name: Yup.string().when("account_type", {
    //   is: (test) => test === 1,
    //   then: () => Yup.string().required("Bank name is required"),
    //   // otherwise: Yup.string().notRequired(),
    // }),
    account_name: Yup.string().when("account_type", {
      is: (test) => test === 1,
      then: () => Yup.string().required("Account name is required"),
    }),
    // account_number: Yup.string().when("account_type", {
    //   is: (test) => test === 1,
    //   then: () =>
    //     Yup.string()
    //       .min(15, "Account number must be 15 digit")
    //       .max(15, "Account number must be 15 digit")
    //       .required("Account number is required"),
    // }),
    ifsc_code: Yup.string().when("account_type", {
      is: (test) => test == 1,
      then: () => Yup.string().required("IFSC code is required")
        .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code format"),
      // confirm_account_number: Yup.string().when("account_type", {
      //   is: (test) => test === 1,
      //   then: () =>
      //     Yup.string()
      //       .oneOf(
      //         [Yup.ref("account_number"), null],
      //         "Account numbers must match"
      //       )
      //       .required("Please confirm your account number"),
      // }),
    }),
    // upi_id: Yup.string().when("account_type", {
    //   is: (test) => test == 2,
    //   then: () => Yup.string().required("UPI ID is required"),
    // }),
    upi_id: Yup.string().when("account_type", {
      is: (value) => value == 2,
      then: (schema) =>
        schema
          .required("UPI ID is required")
          .matches(/^[\w.-]+@[\w.-]+$/, "Enter a valid UPI ID"),
      otherwise: (schema) => schema.notRequired(),
    }),

  }),

  createVendersSchema: Yup.object().shape({
    name: Yup.string().trim().required("This filed is Required"),
    as_of_date: Yup.string().required("This filed is Required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    gst_treatment_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // gst_state: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    gst_no: Yup.string().when("gst_treatment_id", {
      is: (value) => value?.value != 1, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // GST number is not required when value is 1
    }),
    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email format. Example: example@domain.com")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }),
    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
  }),
  // addClaimFullSchema: Yup.object().shape({
  //   sub_category: Yup.string().required("This filed is Required"),

  //   txn_date: Yup.string().required("This filed is Required"),

  //   account_sub_category: Yup.string().required("This filed is Required"),
  //   amount: Yup.string()
  //     .required("Amount is required")
  //     .test(
  //       "is-valid-number",
  //       "Amount must be a valid number",
  //       (value) => {
  //         const numberValue = parseFloat(value);
  //         return !isNaN(numberValue) && value != null && /^\d*\.?\d+$/.test(value.trim());
  //       }
  //     )
  //     .test(
  //       "is-positive-and-non-zero",
  //       "Amount must be greater than zero",
  //       (value) => {
  //         const numberValue = parseFloat(value);
  //         return !isNaN(numberValue) && numberValue > 0;
  //       }
  //     )
  //     .when("sub_category", {
  //       is: (i) => i == 2,
  //       then: (schema) =>
  //         schema.test(
  //           "not-greater-than-balance",
  //           "Amount must not be greater than balance",
  //           function (value) {
  //             const { balance } = this.parent;
  //             const numberValue = parseFloat(value);

  //             if (isNaN(numberValue)) {
  //               return this.createError({
  //                 path: this.path,
  //                 message: "Amount must be a valid number",
  //               });
  //             }

  //             if (balance == null || balance === "" || isNaN(parseFloat(balance))) {
  //               return this.createError({
  //                 path: this.path,
  //                 message: "Valid balance is required for this validation",
  //               });
  //             }

  //             if (numberValue > parseFloat(balance)) {
  //               return this.createError({
  //                 path: this.path,
  //                 message: "Amount must not be greater than balance",
  //               });
  //             }

  //             return true;
  //           }
  //         ),
  //       otherwise: (schema) => schema,
  //     }),

  //   account_id: Yup.string().when("account_sub_category", {
  //     is: (val) => val != "10",
  //     then: () => Yup.string().required("This filed is Required"),
  //     // otherwise: Yup.string(),
  //   }),
  //   expense_category: Yup.string().required("This filed is Required"),

  //   day: Yup.string().when("categoryDetails", {
  //     is: (val) => val == 2,
  //     then: () => Yup.string().required("Day is required"),
  //     otherwise: () => Yup.string().notRequired(),  
  //   }),

  //   rate: Yup.string().when("categoryDetails", {
  //     is: (val) => val == 2,
  //     then: () => Yup.string().required("Rate is required"),
  //     otherwise: () => Yup.string().notRequired(),
  //   }),

  //   revenue: Yup.string().when("categoryDetails", {
  //     is: (val) => val == 3,
  //     then: () => Yup.string().required("Revenue is required"),
  //     otherwise: () => Yup.string().notRequired(),
  //   }),
  //   // party_amount: Yup.string().required("This filed is Required"),
  //   // party_txn_date: Yup.string().required("This filed is Required"),
  //   // party_account_sub_category: Yup.string().required("This filed is Required"),
  //   // party_account_id: Yup.string().when("party_account_sub_category", {
  //   //   is: (val) => val != "10",
  //   //   then: () => Yup.string().required("This filed is Required"),
  //   //   // otherwise: Yup.string(),
  //   // }),

  //   // party_expense_category: Yup.string().required("This filed is Required"),
  // }),


  addClaimFullSchema: Yup.object().shape({
    sub_category: Yup.string().required("This field is required"),
    txn_date: Yup.string().required("This field is required"),
    account_sub_category: Yup.string().required("This field is required"),

    amount: Yup.string()
      .required("Amount is required")
      .test("is-valid-number", "Amount must be a valid number", (value) => {
        const numberValue = parseFloat(value);
        return (
          !isNaN(numberValue) &&
          value != null &&
          /^\d*\.?\d+$/.test(value.trim())
        );
      })
      .test(
        "is-positive-and-non-zero",
        "Amount must be greater than zero",
        (value) => {
          const numberValue = parseFloat(value);
          return !isNaN(numberValue) && numberValue > 0;
        }
      )
      .when("sub_category", {
        is: (i) => i == 2,
        then: (schema) =>
          schema.test(
            "not-greater-than-balance",
            "Amount must not be greater than balance",
            function (value) {
              const { balance } = this.parent;
              const numberValue = parseFloat(value);

              if (isNaN(numberValue)) {
                return this.createError({
                  path: this.path,
                  message: "Amount must be a valid number",
                });
              }

              if (
                balance == null ||
                balance === "" ||
                isNaN(parseFloat(balance))
              ) {
                return this.createError({
                  path: this.path,
                  message: "Valid balance is required for this validation",
                });
              }

              if (numberValue > parseFloat(balance)) {
                return this.createError({
                  path: this.path,
                  message: "Amount must not be greater than balance",
                });
              }

              return true;
            }
          ),
        otherwise: (schema) => schema,
      }),

    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "10",
      then: () => Yup.string().required("This field is required"),
    }),

    expense_category: Yup.string().required("This field is required"),

    // ✅ Enhanced day validation
    no_of_days: Yup.string().when("categoryDetails", {
      is: (val) => val == 2,
      then: () =>
        Yup.string()
          .required("Day is required")
          .test("is-valid-number", "Day must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Day must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          ),
    }),

    // ✅ Enhanced rate validation
    days_rate: Yup.string().when("categoryDetails", {
      is: (val) => val == 2,
      then: () =>
        Yup.string()
          .required("Rate is required")
          .test("is-valid-number", "Rate must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Rate must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          ),
    }),

    // ✅ Enhanced revenue validation
    perc_of_revenue: Yup.string().when("categoryDetails", {
      is: (val) => val == 3,
      then: () =>
        Yup.string()
          .required("Revenue is required")
          .test("is-valid-number", "Revenue must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Revenue must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          )
          .test(
            "max-percentage",
            "Revenue cannot be greater than 100%",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue <= 100;
            }
          ),
    }),
  }),




  addClaimSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),
    balance: Yup.number()
      .required("Balance is required")
      .positive("Balance must be a positive number"),
    amount: Yup.number()
      .required("Amount is required")
      .positive("Amount must be a positive number")
      .transform((value, originalValue) => {
        if (originalValue === "") {
          return null;
        }
        return value;
      })
      // .when("balance", (balance, schema) =>
      //   schema.test({
      //     test: function (value) {
      //       return value <= balance;
      //     },
      //     message: "Amount must not be greater than balance",
      //   })
      // ),
      .when(
        ["balance", "account_sub_category"],
        (balance, account_sub_category, schema) =>
          account_sub_category == 10
            ? schema.test({
              test: (value) => value <= balance,
              message: "Amount must not be greater than balance",
            })
            : schema
      ),
    txn_date: Yup.string().required("This filed is Required"),

    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "10" && val != "11",
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    supplier_account: Yup.boolean(),
    vendor_bank_account: Yup.string().when("supplier_account", {
      is: (test) => test === true,
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    expense_category: Yup.string().required("This filed is Required"),
  }),

  addClaimFullConsignorSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),
    balance: Yup.number(),
    amount: Yup.number()
      .transform((value, originalValue) => (originalValue === "" ? null : value))
      .when(["balance", "sub_category"], ([balance, sub_category], schema) => {
        if (sub_category == 1) {
          // When sub_category == 1, enforce amount <= balance
          return schema
            .required("Amount is required")
            .positive("Amount must be a positive number")
            .test(
              "max-balance",
              "Amount must not be greater than balance",
              (value) => value <= balance
            );
        }
        // For other sub_category values, just required + positive
        return schema.required("Amount is required").positive("Amount must be a positive number");
      }),
    txn_date: Yup.string().required("This filed is Required"),
    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "10" && val != "11",
      then: () => Yup.string().required("This filed is Required"),
    }),
    expense_category: Yup.string().required("This filed is Required"),
    supplier_account: Yup.boolean(),
    vendor_bank_account: Yup.string().when(
      ["sub_category", "supplier_account"],
      {
        is: (sub_category, supplier_account) =>
          sub_category == 2 && supplier_account === true,
        then: () => Yup.string().required("This filed is Required"),
      }
    ),
    no_of_days: Yup.string().when("categoryDetails", {
      is: (val) => val == 2,
      then: () =>
        Yup.string()
          .required("Day is required")
          .test("is-valid-number", "Day must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Day must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          ),
    }),

    // ✅ Enhanced rate validation
    days_rate: Yup.string().when("categoryDetails", {
      is: (val) => val == 2,
      then: () =>
        Yup.string()
          .required("Rate is required")
          .test("is-valid-number", "Rate must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Rate must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          ),
    }),

    // ✅ Enhanced revenue validation
    perc_of_revenue: Yup.string().when("categoryDetails", {
      is: (val) => val == 3,
      then: () =>
        Yup.string()
          .required("Revenue is required")
          .test("is-valid-number", "Revenue must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Revenue must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          )
          .test(
            "max-percentage",
            "Revenue cannot be greater than 100%",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue <= 100;
            }
          ),
    }),
  }),
  addClaimConsignorSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),
    amount: Yup.string().required("This filed is Required"),
    txn_date: Yup.string().required("This filed is Required"),

    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "10" && val != "11",
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),

    expense_category: Yup.string().required("This filed is Required"),
  }),

  addFuelSchemaTrip: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),
    fuel_station_id: Yup.string().when("sub_category", {
      is: (i) => i == 1,
      then: () => Yup.string().required("Fuel station is required "),
      // otherwise: ()=>Yup.string().notRequired(),
    }),

    fuelcard_account_id: Yup.string().when("sub_category", {
      is: (i) => i == 2,
      then: () => Yup.string().required("Fuel card is required "),
      // otherwise: ()=>Yup.string().notRequired(),
    }),
    account_id: Yup.string().when("sub_category", {
      is: (i) => i == 3,
      then: () => Yup.string().required("Account ID is required Cash"),
      // otherwise: Yup.string().notRequired(),
    }),

    fuel_ltr: Yup.number()
      .required("Liters is required")
      .typeError("Fuel liters must be a number")
      .moreThan(0, "Fuel liters must be greater than 0")
      .transform((value, originalValue) => {
        return originalValue === "" || originalValue === "0" ? null : value;
      }),

    fuel_rate: Yup.number()
      .required("Rate is required")
      .typeError("Fuel rate must be a number")
      .moreThan(0, "Fuel rate must be greater than 0")
      .transform((value, originalValue) => {
        return originalValue === "" || originalValue === "0" ? null : value;
      }),

    // amount: Yup.number()
    //   .required("Amount is required")
    //   .typeError("Amount must be a number")
    //   .moreThan(0, "Amount must be greater than 0") // Ensures > 0, zero is not allowed
    //   .transform((value, originalValue) => {
    //     return originalValue === "" || originalValue === "0" ? null : value;
    //   }),

    balance: Yup.number(),
    amount: Yup.number()
      .transform((value, originalValue) => (originalValue === "" ? null : value))
      .when(["balance", "ownerShip"], ([balance, ownerShip], schema) => {
        if (ownerShip == 2) {
          // When sub_category == 1, enforce amount <= balance
          return schema
            .required("Amount is required")
            .positive("Amount must be a positive number")
            .test(
              "max-balance",
              "Amount must not be greater than balance",
              (value) => value <= balance
            );
        }
        // For other sub_category values, just required + positive
        return schema.required("Amount is required").positive("Amount must be a positive number");
      }),
    date: Yup.string().required("This filed is Required"),

    transaction_no: Yup.string().when("sub_category", {
      is: (i) => i == 2,
      then: () => Yup.string().required("Transaction No is Required "),
      // otherwise: Yup.string().notRequired(),
    }),
  }),
  createContractSchema: Yup.object().shape({
    name: Yup.string().required("Contract name is required"),
    // invoice_format: Yup.object().shape({
    //   label: Yup.string().required("Required"),
    // }),
  }),
  createRateSchema: Yup.object().shape({
    consignor_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    contract_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    rate_type: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    amount: Yup.string().required("Amount is Required"),
  }),
  addEditZoneSchema: Yup.object().shape({
    name: Yup.string().trim().required("This field is Required"),
  }),
  addFastagMasterSchema: Yup.object().shape({
    name: Yup.string().required("Name is Required"),
    fastag_company_id: Yup.string().required("Fastag Comapny is Required"),
  }),
  addFuelCardCompanySchema: Yup.object().shape({
    name: Yup.string().required("Name is Required"),
    fuelcard_company_id: Yup.string().required("FuelCard Comapny is Required"),
  }),
  planBranchUpdateSchema: Yup.object().shape({
    // branch_id: Yup.string().required("Branch is Required"),
    branch_id: Yup.object().shape({
      _id: Yup.string().required("Branch is Required"),
    }),
  }),
  planVehicleUpdateSchema: Yup.object().shape({
    // vehicle_id: Yup.string().required("Vehicle is Required"),
    vehicle_id: Yup.object().shape({
      _id: Yup.string().required("This filed is Required"),
    }),
  }),

  addEditChartOfAccountSchema: Yup.object().shape({
    name: Yup.string().required("This Field is Required"),
    account_type_id: Yup.object().shape({
      label: Yup.string().required("This Field is Required"),
    }),
    code: Yup.string().required("This Field is Required"),
    desc: Yup.string().required("This Field is Required"),
  }),
  createBillRaiseSchema: Yup.object().shape({
    invoice_number: Yup.string().required("This filed is Required"),
    billraise_type: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // action_type: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    invoice_date: Yup.string().required("This filed is Required"),
    due_date: Yup.string().required("This filed is Required"),
    consignor_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    consignor_location: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    branch_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // charge_gst_button: Yup.boolean(),
    // consignor_location: Yup.object().when("charge_gst_button", {
    //   is: true,
    //   then: () => Yup.object({
    //     label: Yup.string().required("This field is required"),
    //   }),
    //   otherwise: () => Yup.mixed().notRequired(),
    // }),
  }),

  // fueloutTripSchema: Yup.object().shape({

  //   fuel_out_time: Yup.string().required("This field is required"),
  //   fuel_ltr: Yup.number()
  //     .typeError("Fuel (ltr) must be a number")
  //     .required("This field is required")
  //     .test(
  //       "max-fuel",
  //       `Fuel (ltr) cannot be more than available fuel (${availableFuel})`,
  //       function (value) {
  //         return value <= availableFuel;
  //       }
  //     ),
  //   fuel_amount: Yup.string().required("This field is required"),
  // }),

  endTripSchema: Yup.object().shape({
    end_date: Yup.string().required("This filed is Required"),
    start_kms: Yup.string().when("manage_trip_kms", {
      is: 1,
      then: () => Yup.string().required("This filed is Required"),
      otherwise: () => Yup.string().nullable(),
    }),
    end_kms: Yup.string().when(["start_kms", "manage_trip_kms"], {
      is: (start_kms, manage_trip_kms) =>
        manage_trip_kms === 1 && start_kms > "0",
      then: () =>
        Yup.string()
          .required("This filed is Required")
          .test(
            "is-greater-than-start",
            "End kms must be greater than Start kms",
            function (value) {
              const { start_kms } = this.parent;
              return Number(value) > Number(start_kms);
            }
          ),
      otherwise: () => Yup.string().nullable(),
    }),
  }),

  ewayBillSchima: Yup.object().shape({
    end_date: Yup.string().required("This filed is Required"),
    start_date: Yup.string().required("This filed is Required"),
    eway_bill_number: Yup.string()
      .required("This filed is Required")
      .matches(/^\d{12}$/, "E-way bill number must be exactly 12 digits"),
  }),

  addOwnChargeSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),
    expense_category: Yup.string().required("Category name is Required"),

    amount: Yup.number()
      .typeError("Amount must be a valid number")
      .required("Amount is required")
      .min(0, "Amount cannot be negative"),
    txn_date: Yup.string().required("This filed is Required"),
    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "10" && val != "11",
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    isCheck: Yup.boolean(),
    vendor_account: Yup.string().when("isCheck", {
      is: true,
      then: () => Yup.string().required("This field is Required"),
    }),
    no_of_days: Yup.string().when("categoryDetails", {
      is: (val) => val == 2,
      then: () =>
        Yup.string()
          .required("Day is required")
          .test("is-valid-number", "Day must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Day must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          ),
    }),

    // ✅ Enhanced rate validation
    days_rate: Yup.string().when("categoryDetails", {
      is: (val) => val == 2,
      then: () =>
        Yup.string()
          .required("Rate is required")
          .test("is-valid-number", "Rate must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Rate must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          ),
    }),

    // ✅ Enhanced revenue validation
    perc_of_revenue: Yup.string().when("categoryDetails", {
      is: (val) => val == 3,
      then: () =>
        Yup.string()
          .required("Revenue is required")
          .test("is-valid-number", "Revenue must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Revenue must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          )
          .test(
            "max-percentage",
            "Revenue cannot be greater than 100%",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue <= 100;
            }
          ),
    }),
  }),
  addMultiOwnChargeSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),
    txn_date: Yup.string().required("This filed is Required"),
    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "10" && val != "11",
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    isCheck: Yup.boolean(),
    vendor_account: Yup.string().when("isCheck", {
      is: (test) => test === true,
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    expenseArray: Yup.array().of(
      Yup.object().shape({
        category: Yup.string().required("This filed is Required"),
        amount: Yup.string().required("This filed is Required"),
      })
    ),
  }),
  addClaimOwnFullSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),
    amount: Yup.string()
      .required("Amount is required")
      .test("is-valid-number", "Amount must be a valid number", (value) => {
        const numberValue = parseFloat(value);
        return (
          !isNaN(numberValue) &&
          value != null &&
          /^\d*\.?\d+$/.test(value.trim())
        );
      })
      .test(
        "is-positive-and-non-zero",
        "Amount must be greater than zero",
        (value) => {
          const numberValue = parseFloat(value);
          return !isNaN(numberValue) && numberValue > 0;
        }
      )
      .when("sub_category", {
        is: (i) => i == 1,
        then: (schema) =>
          schema.test(
            "not-greater-than-balance",
            "Amount must not be greater than balance",
            function (value) {
              const { balance } = this.parent;
              const numberValue = parseFloat(value);
              console.log(balance)
              // ✅ Check if amount is valid number
              if (isNaN(numberValue)) {
                return this.createError({
                  path: this.path,
                  message: "Amount must be a valid number",
                });
              }

              // ✅ Check if balance is valid
              if (
                balance == null ||
                balance === "" ||
                isNaN(parseFloat(balance))
              ) {
                return this.createError({
                  path: this.path,
                  message: "Valid balance is required for this validation",
                });
              }

              // ✅ Check if amount exceeds balance
              if (numberValue > parseFloat(balance)) {
                return this.createError({
                  path: this.path,
                  message: "Amount must not be greater than balance",
                });
              }

              // ✅ All validations passed
              return true;
            }
          ),
        otherwise: (schema) => schema,
      }),
    // amount: Yup.string()
    //   .required("Amount is required")
    //   .test("is-valid-number", "Amount must be a valid number", (value) => {
    //     const numberValue = parseFloat(value);
    //     return (
    //       !isNaN(numberValue) &&
    //       value != null &&
    //       /^\d*\.?\d+$/.test(value.trim())
    //     );
    //   })
    //   .test(
    //     "is-positive-and-non-zero",
    //     "Amount must be greater than zero",
    //     (value) => {
    //       const numberValue = parseFloat(value);
    //       return !isNaN(numberValue) && numberValue > 0;
    //     }
    //   )
    //   .when("sub_category", {
    //     is: (i) => i == 1,
    //     then: (schema) =>
    //       schema.test(
    //         "not-greater-than-balance",
    //         "Amount must not be greater than balance",
    //         function (value) {
    //           const { balance } = this.parent;
    //           const numberValue = parseFloat(value);

    //           if (isNaN(numberValue)) {
    //             return this.createError({
    //               path: this.path,
    //               message: "Amount must be a valid number",
    //             });
    //           }

    //           if (
    //             balance == null ||
    //             balance === "" ||
    //             isNaN(parseFloat(balance))
    //           ) {
    //             return this.createError({
    //               path: this.path,
    //               message: "Valid balance is required for this validation",
    //             });
    //           }

    //           if (numberValue > parseFloat(balance)) {
    //             return this.createError({
    //               path: this.path,
    //               message: "Amount must not be greater than balance",
    //             });
    //           }

    //           return true;
    //         }
    //       ),
    //     otherwise: (schema) => schema,
    //   }),
    txn_date: Yup.string().required("This filed is Required"),

    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "10" && val != "11",
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    expense_category: Yup.string().required("This filed is Required"),
    // party_amount: Yup.string().required("This filed is Required"),
    // party_txn_date: Yup.string().required("This filed is Required"),
    // party_account_sub_category: Yup.string().required("This filed is Required"),
    // party_account_id: Yup.string().when("party_account_sub_category", {
    //   is: (val) => val != "10" && val != "11",
    //   then: () => Yup.string().required("This filed is Required"),
    //   // otherwise: Yup.string(),
    // }),

    // party_expense_category: Yup.string().required("This filed is Required"),
    // ✅ Enhanced day validation
    no_of_days: Yup.string().when("categoryDetails", {
      is: (val) => val == 2,
      then: () =>
        Yup.string()
          .required("Day is required")
          .test("is-valid-number", "Day must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Day must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          ),
    }),

    // ✅ Enhanced rate validation
    days_rate: Yup.string().when("categoryDetails", {
      is: (val) => val == 2,
      then: () =>
        Yup.string()
          .required("Rate is required")
          .test("is-valid-number", "Rate must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Rate must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          ),
    }),

    // ✅ Enhanced revenue validation
    perc_of_revenue: Yup.string().when("categoryDetails", {
      is: (val) => val == 3,
      then: () =>
        Yup.string()
          .required("Revenue is required")
          .test("is-valid-number", "Revenue must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Revenue must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          )
          .test(
            "max-percentage",
            "Revenue cannot be greater than 100%",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue <= 100;
            }
          ),
    }),
  }),
  addClaimOwnSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),

    amount: Yup.number()
      .required("Amount is required")
      .typeError("Amount must be a number")
      .moreThan(0, "Amount must be greater than 0") // Ensures > 0, zero is not allowed
      .transform((value, originalValue) => {
        return originalValue === "" || originalValue === "0" ? null : value;
      }),
    txn_date: Yup.string().required("This filed is Required"),

    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
  is: (val) => val != "11" && val != "1",
  then: () => Yup.string().required("This field is Required"),
}),
    supplier_account: Yup.boolean(),
    vendor_bank_account: Yup.string().when("supplier_account", {
      is: (test) => test === true,
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    expense_category: Yup.string().required("This filed is Required"),

  }),

  addOtherChargesSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),

    amount: Yup.number()
      .required("Amount is required")
      .typeError("Amount must be a number")
      .moreThan(0, "Amount must be greater than 0") // Ensures > 0, zero is not allowed
      .transform((value, originalValue) => {
        return originalValue === "" || originalValue === "0" ? null : value;
      }),
    txn_date: Yup.string().required("This filed is Required"),

    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "11" && val != "1",
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    supplier_account: Yup.boolean(),
    isCheck: Yup.boolean(),
    vendor_bank_account: Yup.string().when("isCheck", {
      is: (test) => test === true,
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    expense_category: Yup.string().required("This filed is Required"),
    vendor_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "11",
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    // ✅ Enhanced day validation
    no_of_days: Yup.string().when("categoryDetails", {
      is: (val) => val == 2,
      then: () =>
        Yup.string()
          .required("Day is required")
          .test("is-valid-number", "Day must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Day must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          ),
    }),

    // ✅ Enhanced rate validation
    days_rate: Yup.string().when("categoryDetails", {
      is: (val) => val == 2,
      then: () =>
        Yup.string()
          .required("Rate is required")
          .test("is-valid-number", "Rate must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Rate must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          ),
    }),

    // ✅ Enhanced revenue validation
    perc_of_revenue: Yup.string().when("categoryDetails", {
      is: (val) => val == 3,
      then: () =>
        Yup.string()
          .required("Revenue is required")
          .test("is-valid-number", "Revenue must be a valid number", (value) => {
            const numberValue = parseFloat(value);
            return (
              !isNaN(numberValue) &&
              value != null &&
              /^\d*\.?\d+$/.test(value.trim())
            );
          })
          .test(
            "is-positive-and-non-zero",
            "Revenue must be greater than zero",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue > 0;
            }
          )
          .test(
            "max-percentage",
            "Revenue cannot be greater than 100%",
            (value) => {
              const numberValue = parseFloat(value);
              return !isNaN(numberValue) && numberValue <= 100;
            }
          ),
    }),
  }),

  addOtherSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),

    amount: Yup.string().required("This filed is Required"),
    txn_date: Yup.string().required("This filed is Required"),

    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "10" && val != "11",
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    supplier_account: Yup.boolean(),
    vendor_bank_account: Yup.string().when("supplier_account", {
      is: (test) => test === true,
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
    expense_category: Yup.string().required("This filed is Required"),
  }),

  addPayDriverSchema: Yup.object().shape({
    expense_category: Yup.string().required("This filed is Required"),
    amount: Yup.string().required("Amount is required"),
    txn_date: Yup.string().required("This filed is Required"),
    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().required("This filed is Required"),
    vendor_account: Yup.string().when("isCheck", {
      is: true,
      then: () => Yup.string().required("This field is Required"),
    }),
  }),

  addAddressBook: Yup.object().shape({
    name: Yup.string().required("This field is This filed is Required"),
    category: Yup.string().required("This field is Required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    associate_party_id: Yup.string()
      // .nullable()
      .when("category", {
        is: (category) => ["1", "2", "3"].includes(category), // Condition: category is 1, 2, or 3
        then: () =>
          Yup.array()
            .min(1, "At least one associate is required") // Ensure at least one object exists
            .of(
              Yup.object().shape({
                _id: Yup.string().required("Associate ID is required"), // Ensure _id is present
                name: Yup.string().nullable(), // Name is optional
              })
            ),
        otherwise: () => Yup.string().nullable(), // Not required otherwise
      }),
    // contact_no: Yup.string().required("This filed is Required"),
    // email_id: Yup.string().required("This filed is Required"),
    // address_line1: Yup.string().required("This filed is Required"),

    // state: Yup.object().shape({
    //   label: Yup.string().required("city is required"),
    // }),
    // city: Yup.object().shape({
    //   label: Yup.string().required("city is required"),
    // }),
    // pincode: Yup.string().required("This filed is Required"),
    // code: Yup.string().required("This filed is Required"),
    zone_id: Yup.string().required("This field is Required"),
    branch_id: Yup.string().required("This field is Required"),
    // contact_no: Yup.string()
    //   .nullable()
    //   .notRequired() // Makes the field optional
    //   .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
    //     if (!value) return true; // Skip validation if empty
    //     return mobileFormateRehex.test(value); // Validate only if a value exists
    //   }),
  }),
  addAddressImport: Yup.object().shape({
    category: Yup.string().required("Amount is required"),
    associate_party_id: Yup.array()
      .nullable()
      .min(1, "At least one Associate Party is required") // Ensure at least one object exists
      .of(
        Yup.object().shape({
          _id: Yup.string().required("Associate Party is required"), // Ensures _id exists
          name: Yup.string().nullable(), // Name is optional
        })
      ),
    location_point: Yup.string().required("Location point is required"),
    file: Yup.string().required("File is required"),
  }),

  addAddressBookContinue: Yup.object().shape({
    name: Yup.string().trim().required("Name is Required"),
    category: Yup.string().required("Category is required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email address")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }), // Validat
    associate_party_id: Yup.string()
      .nullable()
      .when("category", {
        is: (category) => ["1", "2", "3"].includes(category), // Condition: category is 1, 2, or 3
        then: () =>
          Yup.array()
            .min(1, "At least one associate is required") // Ensure at least one object exists
            .of(
              Yup.object().shape({
                _id: Yup.string().required("Associate ID is required"), // Ensure _id is present
                name: Yup.string().nullable(), // Name is optional
              })
            ),
        otherwise: () => Yup.string().nullable(), // Not required otherwise
      }),
    gst_treatment_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
    city: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    gst_no: Yup.string().when("gst_treatment_id", {
      is: (value) => value?.value != 1, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // GST number is not required when value is 1
    }),
  }),

  addPoSchema: Yup.object().shape({
    po_date: Yup.string().required("This filed is Required"),
    from_location: Yup.string().required("This filed is Required"),
    to_location: Yup.string().required("This filed is Required"),
  }),

  addPostIndentSchima: Yup.object().shape({
    indent_date: Yup.string().required("Indent Date is Required"),
    indent_date: Yup.string().required("This filed is Required"),
    lorry_type_id: Yup.string().required("This filed is Required"),
    vehicle_type_id: Yup.string().required("This filed is Required"),
    consignor_id: Yup.string().required("This filed is Required"),
    weight: Yup.string()
      .required("Weight is Required")
      .test("is-positive", "Weight must be greater than 0", (value) => {
        return value && parseFloat(value) > 0; // Convert to number and check if greater than zero
      }),
    material_type_id: Yup.string().required("Material is Required"),

    //  file: Yup.mixed().required("File is required"),
    freight_amount: Yup.string().when("freight_type", {
      is: (ownership) => ownership == 4,
      then: () =>
        Yup.string()
          .required("Freight Amount is Required")
          .test(
            "is-positive",
            "Freight Amount must be greater than 0",
            (value) => {
              return value && parseFloat(value) > 0; // Check if greater than zero
            }
          ),
    }),
    freight_rate: Yup.string().when("freight_type", {
      is: (ownership) => ownership == 6,
      then: () => Yup.string().required("Freight Rate is Required"),
    }),
    payment_percentage: Yup.string().when("payment_terms", {
      is: (ownership) => ownership == 1,
      then: () => Yup.string().required("Payment Percentage is Required"),
    }),

    branch_id: Yup.string().required(" Branch is Required"),
    // assign_to:Yup.string().required("This filed is Required"),

    // connection_id: Yup.string().when('is_allow_visibility', {
    //   is: (ownership) => ownership == 1,
    //   then:()=> Yup.string().required('Required'),

    // }),

    toLoction: Yup.array().of(
      Yup.object().shape({
        to_city: Yup.string().required("to Location is Required"),
        to_state: Yup.string().required("To Location is  Required"),
        // lat: Yup.string().nullable(),  // If lat can be null
        // long: Yup.string().nullable(), // If long can be null
        po_list: Yup.array().when("id", {
          is: (id) => !!id, // Check if id exists
          then: () =>
            Yup.array().of(
              Yup.object().shape({
                from_location: Yup.string().required(
                  "From Location is Required"
                ),
                to_location: Yup.string().required(
                  "Pickup and Drop is Required"
                ),
                from_state: Yup.string().required("To State is required"),
                to_state: Yup.string().required("To State is required"),
              })
            ),
          otherwise: () => Yup.array().notRequired(), // If no id, skip validation
        }),
      })
    ),

    // toLoction: Yup.array().of(
    //   Yup.object().shape({
    //     to_city: Yup.string().required("This filed is Required"),
    //   })
    // ),
    fromLoction: Yup.array().of(
      Yup.object().shape({
        from_city: Yup.string().required("From Location is  Required"),
      })
    ),

    responses: Yup.string().required("This filed is Required"),
  }),

  addNewConnection: Yup.object().shape({
    name: Yup.string().required("This filed is Required"),
  }),

  planImportSchema: Yup.object().shape({
    // consignor_id: Yup.string().required("This filed is Required"),
    consignor_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    contract_id: Yup.string().required("This filed is Required"),
    file: Yup.string().required("This filed is Required"),
  }),
  contractImportSchema: Yup.object().shape({
    consignor_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    contract_id: Yup.string().required("This filed is Required"),
    file: Yup.mixed().required("File is required"),
    vehicle_type_id: Yup.string().required("This filed is Required"),
    matrix_allowed: Yup.string().required("This filed is Required"),
  }),

  lrImportSchema: Yup.object().shape({
    consignor_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    contract_id: Yup.string().required("This filed is Required"),
    file: Yup.mixed().required("File is required"),
    branch_id: Yup.string().required("This filed is Required"),
  }),
  createBidSchema: Yup.object().shape({
    amount: Yup.string().required("This filed is Required"),
  }),

  cashSchema: Yup.object().shape({
    cash_name: Yup.string().required("Cash account Name is required"),
    cash_opting_bal: Yup.string()
      .required("Opening Balance is required"),
    // .test("not-zero", "Opening Balance must be greater than 0", (value) => {
    //   return value !== "0" && parseFloat(value) > 0;
    // }),
    // cash_opting_bal: Yup.string().required("Opening Balance is required"),
    cash_credit_or_debit: Yup.string().required("Credit or Debit is required"),
    // firm_id: Yup.string().required("Credit or Debit is required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("Firm is Required"),
    }),
  }),

  bankSchema: Yup.object().shape({
    holder_name: Yup.string().required("Account Name is required"),
    number: Yup.string().required("Account Number is required"),
    // .min(15, `Enter 15 digit account number`)
    // .max(15, `Enter 15 digit account number`),
    // .required("Account Number is required"),
    ifsc: Yup.string()
      .test(
        "valid-ifsc",
        "Invalid IFSC code format",
        (value) =>
          !value || /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)
      ).required("IFSC code is required"),
    // .required("IFSC code is required"),
    // Yup.string().required("IFSC Code is required"),
    // bank: Yup.string().required("Bank Name is required"),
    // bank_opening_balance: Yup.string().required("Opening Balance is required"),
    bank_credit_or_debit: Yup.string().required("Credit or Debit is required"),
    bank_opening_balance: Yup.string().required("Opening Balance is required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("Firm is Required"),
    }),
    // .test("not-zero", "Opening Balance must be greater than 0", (value) => {
    //   return value !== "0" && parseFloat(value) > 0;
    // }),
    // ifsc: Yup.string().required("IFSC code is required")
    //     .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code format")
  }),

  otherSchema: Yup.object().shape({
    other_name: Yup.string().required("Other Account Name is required"),
    // other_opening_balance: Yup.string().required("Opening Balance is required"),
    other_opening_balance: Yup.string()
      .required("Opening Balance is required"),
    // .test("not-zero", "Opening Balance must be greater than 0", (value) => {
    //   return value !== "0" && parseFloat(value) > 0;
    // }),
    other_credit_or_debit: Yup.string().required("Credit or Debit is required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("Firm is Required"),
    }),
  }),

  fuelSchema: Yup.object().shape({
    fuel_card_number: Yup.string().required("Fuel Card Number is required"),
    associate_vehicle_id: Yup.string().required("Vehicle ID is required"),
    fuel_opening_balance: Yup.string().required("Opening Balance is required"),
    // fuel_credit_or_debit: Yup.string().required("Credit or Debit is required"),
    fuel_opening_balance: Yup.string()
      .required("Opening Balance is required"),
    // .test("not-zero", "Opening Balance must be greater than 0", (value) => {
    //   return value !== "0" && parseFloat(value) > 0;
    // }),
    fuel_card_master_id: Yup.string().required(
      "Fuel Card Master ID is required"
    ),
  }),

  fastagSchema: Yup.object().shape({
    fastag_id_number: Yup.string().required("Fastag Number is required"),
    fastag_associate_vehicle_id: Yup.string().required(
      "Vehicle ID is required"
    ),
    // fastag_opening_balance: Yup.string().required(
    //   "Opening Balance is required"
    // ),
    fastag_opening_balance: Yup.string()
      .required("Opening Balance is required"),
    // .test("not-zero", "Opening Balance must be greater than 0", (value) => {
    //   return value !== "0" && parseFloat(value) > 0;
    // }),
    fastag_credit_or_debit: Yup.string().required(
      "Credit or Debit is required"
    ),
    fastag_master_id: Yup.string().required("Fastag Master ID is required"),
  }),

  multiExpenseTripSchema: Yup.object().shape({
    // type: Yup.string().required("This filed is Required"),
    // date: Yup.string().required("This filed is Required"),
    // account_id: Yup.string().when("account_sub_category", {
    //   is: (val) => val != "15",
    //   then: () => Yup.string().required("This filed is Required"),
    // }),
    // account_sub_category: Yup.string().required("This filed is Required"),
    // invoice_date: Yup.string().required("This filed is Required"),
    // place_of_supply: Yup.object()
    //   .nullable()
    //   .shape({
    //     name: Yup.string().required("State is required"),
    //   })
    //   .when("is_gst", {
    //     is: true,
    //     then: (schema) =>
    //       schema.required("Place of supply is required when GST is true"),
    //     otherwise: (schema) => schema.nullable(),
    //   }),
    // vendor_id: Yup.string().when(["is_gst", "account_sub_category"], {
    //   is: (is_gst, account_sub_category) =>
    //     is_gst == true || account_sub_category == "15",
    //   then: () =>
    //     Yup.string().required("Vendor is required when GST is true"),
    // }),
    expenseArray: Yup.array()
      .of(
        Yup.object().shape({
          category: Yup.string().required("This filed is Required"),

          // Validation for calculation_type === 2 (Days-based)
          no_of_days: Yup.string().when("categoryDetails", {
            is: (categoryDetails) => categoryDetails?.calculation_type === 2,
            then: () => Yup.string()
              .required("No of Days is required")
              .test('is-greater-than-zero', 'No of Days must be greater than 0', value => {
                return parseFloat(value) > 0;
              }),
            otherwise: () => Yup.string().notRequired(),
          }),

          days_rate: Yup.string().when("categoryDetails", {
            is: (categoryDetails) => categoryDetails?.calculation_type === 2,
            then: () => Yup.string()
              .required("Rate is required")
              .test('is-greater-than-zero', 'Rate must be greater than 0', value => {
                return parseFloat(value) > 0;
              }),
            otherwise: () => Yup.string().notRequired(),
          }),

          // Validation for calculation_type === 3 (Percentage-based)
          perc_of_revenue: Yup.string().when("categoryDetails", {
            is: (categoryDetails) => categoryDetails?.calculation_type === 3,
            then: () => Yup.string()
              .required("% of Revenue is required")
              .test('is-valid-percentage', '% of Revenue must be between 0 and 100', value => {
                const num = parseFloat(value);
                return num > 0 && num <= 100;
              }),
            otherwise: () => Yup.string().notRequired(),
          }),

          // Amount validation (required for all, but can be auto-calculated)
          amount: Yup.string().required("This filed is Required"),

          // Tax validation when GST is applicable
          // tax: Yup.string().when("is_gst", {
          //   is: 1,
          //   then: () => Yup.string().required("This filed is Required"),
          //   otherwise: () => Yup.string().notRequired(),
          // }),
        })
      )

  }),
  addExpenseAccountSchema: Yup.object().shape({
    branch_id: Yup.object().shape({
      label: Yup.string().required("Branch name is required"),
    }),
    // type: Yup.string().required("This filed is Required"),
    date: Yup.string().required("This filed is Required"),
    // account_id: Yup.string().when("account_sub_category", {
    //   is: (val) => val != "15",
    //   then: () => Yup.string().required("This filed is Required"),
    //   // otherwise: Yup.string(),
    // }),
    // account_sub_category: Yup.string().required("This filed is Required"),
    // invoice_number: Yup.string().required("This filed is Required"),
    invoice_date: Yup.string().required("This filed is Required"),
    is_gst: Yup.boolean(),
    place_of_supply: Yup.object()
      // .nullable()
      .when("is_gst", {
        is: (is_gst) => is_gst === true,
        then: (schema) =>
          schema
            .shape({
              label: Yup.string().required("Place of supply is required when GST is true"),
            }),
        otherwise: (schema) => schema.nullable(),
      }),
    vendor_id: Yup.object()
      // .nullable()
      .when(["is_gst", "account_sub_category"], {
        is: (is_gst, account_sub_category) =>
          is_gst === true || account_sub_category === "15",
        then: (schema) =>
          schema
            .shape({
              label: Yup.string().required("Vendor is required when GST is true"),
            }),
        otherwise: (schema) => schema.nullable(),
      }),
    expenseArray: Yup.array()
      .of(
        Yup.object().shape({
          category: Yup.string().required("This filed is Required"),
          tax: Yup.string().when("is_gst", {
            is: 1,
            then: Yup.string().required("This filed is Required"), //Required when GST is applicable
            otherwise: Yup.string().notRequired(),
          }),
          amount: Yup.string().required("This filed is Required"),
        })
      )
      .when("is_gst", {
        is: (i) => i == false,
        then: () =>
          Yup.array().of(
            Yup.object().shape({
              category: Yup.string().required("This filed is Required"),
              amount: Yup.string().required("This filed is Required"),
            })
          ),
        otherwise: () =>
          Yup.array().of(
            Yup.object().shape({
              category: Yup.string().required("This filed is Required"),
              tax: Yup.string().required("This filed is Required"), //Required when GST is applicable
              amount: Yup.string().required("This filed is Required"),
            })
          ),
      }),
  }),
  addUnitContinue: Yup.object().shape({
    name: Yup.string().trim().required("This field is Required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email format. Example: example@domain.com")
      .test("domain-check", "Email domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        return !/\d/.test(domain); // Ensure domain does not contain any digits
      }),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
    associate_party_id: Yup.array()
      .nullable()
      .min(1, "At least one Associate Party is required") // Ensure at least one object exists
      .of(
        Yup.object().shape({
          _id: Yup.string().required("Associate Party is required"), // Ensures _id exists
          name: Yup.string().nullable(), // Name is optional
        })
      ),
    gst_treatment_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // gst_state: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    gst_no: Yup.string().when("gst_treatment_id", {
      is: (value) => value?.value != 1, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // GST number is not required when value is 1
    }),
    city: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
  }),

  consigneeSchemaForSecondActiveTab: Yup.object().shape({
    gst_treatment_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // gst_state: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    gst_no: Yup.string().when("gst_treatment_id", {
      is: (value) => value?.value != 1, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // GST number is not required when value is 1
    }),
    city: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
  }),

  addUnitSchemaAdd: Yup.object().shape({
    name: Yup.string().required("Name is Required"),
    zone_id: Yup.string().required("Zone is Required "),
    branch_id: Yup.string().required("Branch is Required "),

    associate_party_id: Yup.array()
      // .nullable()
      .min(1, "At least one Associate Party is required") // Ensure at least one object exists
      .of(
        Yup.object().shape({
          _id: Yup.string().required("Associate Party is required"), // Ensures _id exists
          name: Yup.string().nullable(), // Name is optional
        })
      ),
  }),

  addConsigneeSchemaAdd: Yup.object().shape({
    name: Yup.string().trim().required("Name is Required"),
    zone_id: Yup.string().required("Zone is Required "),
    branch_id: Yup.string().required("Branch is Required "),

    associate_party_id: Yup.array()
      // .nullable()
      .min(1, "At least one Associate Party is required") // Ensure at least one object exists
      .of(
        Yup.object().shape({
          _id: Yup.string().required("Associate Party is required"), // Ensures _id exists
          name: Yup.string().nullable(), // Name is optional
        })
      ),
    // consignor_id: Yup.string().required("This field is Required"),
  }),

  fundTransferSchema: Yup.object().shape({
    amount: Yup.string()
      .required("Amount is Required")
      .test("not-zero", "Amount must be greater than 0", (value) => {
        return value !== "0" && parseFloat(value) > 0;
      }),
    from_account_id: Yup.string().when("from_account_sub_category ", {
      is: (i) => i == 11,
      then: () => Yup.string().required("From Account is Required"),
      // otherwise: Yup.string().notRequired(),
    }),
    to_account_id: Yup.string().when("to_account_sub_category ", {
      is: (i) => i == 11,
      then: () => Yup.string().required("To Account is Required"),
      // otherwise: Yup.string().notRequired(),
    }),
  }),

  addFuelSchema: Yup.object().shape({
    sub_category: Yup.string().required("Category is Required"),
    fuel_station_id: Yup.string().when("sub_category", {
      is: (i) => i == 1,
      then: () => Yup.string().required("Fuel station is required "),
    }),
    account_id: Yup.string().when("sub_category", {
      is: (i) => i == 3,
      then: () => Yup.string().required("Account ID is required Cash"),
    }),

    fuel_ltr: Yup.number()
      .required("Liters is required")
      .typeError("Fuel liters must be a number")
      .moreThan(0, "Fuel liters must be greater than 0")
      .transform((value, originalValue) => {
        return originalValue === "" || originalValue === "0" ? null : value;
      }),

    fuel_rate: Yup.number()
      .required("Rate is required")
      .typeError("Fuel rate must be a number")
      .moreThan(0, "Fuel rate must be greater than 0")
      .transform((value, originalValue) => {
        return originalValue === "" || originalValue === "0" ? null : value;
      }),

    amount: Yup.number()
      .required("Amount is required")
      .typeError("Amount must be a number")
      .moreThan(0, "Amount must be greater than 0") // Ensures > 0, zero is not allowed
      .transform((value, originalValue) => {
        return originalValue === "" || originalValue === "0" ? null : value;
      }),

    date: Yup.string().required("Date is Required"),


  }),
  createStaff: Yup.object().shape({
    name: Yup.string().required("This filed is Required"),
    as_of_date: Yup.string().required("This filed is Required"),
    firm_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    pan_no: Yup.string()
      .nullable()
      .notRequired() // Field is optional
      .test(
        "is-valid-pan",
        "PAN number must be 10 characters (e.g., ABCDE1234F)",
        (value) => {
          if (!value) return true; // Skip validation if field is empty
          return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value); // PAN format: 5 letters, 4 digits, 1 letter
        }
      ),
    aadhar_no: Yup.string()
      .nullable()
      .notRequired() // Field is optional
      .test(
        "is-valid-aadhar",
        "Aadhar number must be exactly 12 digits",
        (value) => {
          if (!value) return true; // Skip validation if field is empty
          return /^\d{12}$/.test(value); // Only valid if exactly 12 digits
        }
      ),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
  }),
  selectConsigneeLrModalSchema: Yup.object().shape({
    consignee_id: Yup.object().shape({
      label: Yup.string().required("Consignee address is Required"),
    }),
  }),

  addFreightBalanceSchema: Yup.object().shape({
    txn_date: Yup.string().required("This filed is Required"),
    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().required("This filed is Required"),
    isCheck: Yup.boolean(),
    vendor_account: Yup.string().when("isCheck", {
      is: (test) => test === true,
      then: () => Yup.string().required("This filed is Required"),
      // otherwise: Yup.string(),
    }),
  }),

  // addFreigthSchema: Yup.object().shape({
  //   txn_date: Yup.string().required("This filed is Required"),
  //   // amount: Yup.string().required("This filed is Required"),
  //   account_sub_category: Yup.string().required("This filed is Required"),
  //   account_id: Yup.string().required("This filed is Required"),
  //   isCheck: Yup.boolean(),
  //   // vendor_bank_account: Yup.string().when("isCheck", {
  //   //   is: (test) => test === true,
  //   //   then: () => Yup.string().required("This filed is Required"),
  //   //   // otherwise: Yup.string(),
  //   // }),
  // }),
  createPaymentInvoiceDetailsSchema: Yup.object().shape({
    amount: Yup.string().required("This filed is Required"),
    date: Yup.string().required("This filed is Required"),
    account_category: Yup.string().required("This filed is Required"),
    account_sub_category: Yup.string().required("This filed is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "11",
      then: () => Yup.string().required("This filed is Required"),
    }),
  }),
  createTdsInvoiceDetailsSchema: Yup.object().shape({
    amount: Yup.string().required("This filed is Required"),
    date: Yup.string().required("This filed is Required"),
    // tds_deduction: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
  }),
  addClaimInvoiceDetailsSchema: Yup.object().shape({
    sub_category: Yup.string().required("This filed is Required"),

    date: Yup.string().required("This filed is Required"),
    lr_id: Yup.string().required("This filed is Required"),
    account_sub_category: Yup.string().required("This filed is Required"),
    amount: Yup.string()
      .required("Amount is required") // Ensure the field is required
      .test(
        "is-positive-number",
        "Amount must be a positive number",
        (value) => {
          const numberValue = parseFloat(value);
          return !isNaN(numberValue) && numberValue > 0; // Validate that it's a positive number
        }
      )
      .when("account_sub_category", {
        is: (i) => i == 10, // Check if `account_sub_category` is 10
        then: () =>
          Yup.string()
            .required("Amount is required") // Ensure it's required
            .test(
              "not-greater-than-balance",
              "Amount must not be greater than balance",
              function (value) {
                const { balance } = this.parent; // Access balance from the parent context
                const numberValue = parseFloat(value);

                if (isNaN(numberValue)) {
                  return this.createError({
                    path: this.path,
                    message: "Amount must be a valid number",
                  });
                }

                if (balance == null || balance === "") {
                  return this.createError({
                    path: this.path,
                    message: "Balance is required for this validation",
                  });
                }

                if (numberValue > balance) {
                  return this.createError({
                    path: this.path,
                    message: "Amount must not be greater than balance",
                  });
                }

                return true; // Pass validation
              }
            ),
        otherwise: () => Yup.string().required("Amount is required"), // For other cases, just required
      }),
    expense_category: Yup.string().required("This filed is Required"),
  }),

  addExpenseCategorySchema: Yup.object().shape({
    name: Yup.string().required("Name is Required"),
  }),
  addGpsIntrigationSchema: Yup.object().shape({
    name: Yup.string().trim().required("Name is Required"),
    access_token: Yup.string().trim().required("Token is Required"),
  }),
  createEwayBillModalSchema: Yup.object().shape({
    // party: Yup.object().shape({
    //   label: Yup.string().required("Party name is required"),
    // }),
    branch_id: Yup.object().shape({
      label: Yup.string().required("Branch name is required"),
    }),
    eway_bill_no: Yup.string().trim().required("Eway bill number is Required"),
  }),
  createEwayBillModalSchema2: Yup.object().shape({
    party: Yup.object().shape({
      label: Yup.string().required("Party name is required"),
    }),
  }),
  ewayIntegrationSchema: Yup.object().shape({
    gstin: Yup.string()
      .required("GST number is required")
      .matches(gstFormateRegex, "Invalid GST format")
      .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
      .max(15, "GST number must be 15 characters long"),
    userid: Yup.string().required("User ID is required"),
    password: Yup.string().required("Password is required"),
  }),
  extandEwayBillSchema: Yup.object().shape({
    // fromPincode: Yup.string().required("From Pin Code is required"),
    // toPincode: Yup.string().required("To Pin Code is required"),
    extnRsnCode: Yup.object().shape({
      label: Yup.string().required("Extension Remarks is required"),
    }),
    // extnRemarks: Yup.object().shape({
    //   label: Yup.string().required("Extension Remarks is required"),
    // }),
    remainingDistance: Yup.string().required("Remaining distance is required"),
    locationPincode: Yup.string().required("Please Select Location"),
  }),
  ewayBillChecker: Yup.object().shape({
    eway_date: Yup.string().required("Date is Required"),
    branch_id: Yup.object().shape({
      label: Yup.string().required("Branch is Required"),
    }),
  }),
  googleMapSchema: Yup.object().shape({
    postalCode: Yup.string()
      .required("Pin Code is required")
      .test("is-6-digit-distance", "Please enter exactly 6 digits", (value) => {
        if (!value) return true;
        return /^\d{6}$/.test(value);
      }),
  }),
  createTripUpdateSchima: Yup.object().shape({
    driver_id: Yup.mixed().when("addDriverMandatory", {
      is: (addDriverMandatory) => addDriverMandatory === 1,
      then: () =>
        Yup.object({
          name: Yup.string().required("Driver is required"),
        }).required("Driver is required"),
      otherwise: () => Yup.mixed().notRequired(),
    }),

    // LoadingChalli validation
    loadingChalli: Yup.array().when("loadingChalliMandatory", {
      is: (loadingChalliMandatory) => loadingChalliMandatory === 1,
      then: () =>
        Yup.array().test(
          "loading-challi-required",
          "At least one loading challi input is required",
          function (value) {
            if (!value || !Array.isArray(value)) return false;

            // Check first 20 values (excluding total at index 20)
            const inputs = value.slice(0, 20);
            return inputs.some(
              (input) => input && input.toString().trim() !== ""
            );
          }
        ),
      otherwise: () => Yup.array().notRequired(),
    }),
  }),
  insuranceSchema: Yup.object().shape({
    doc_type_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    // company_name: Yup.string().trim().required("This field is Required"),
    // document_no: Yup.string().required("This field is Required"),
    issue_date: Yup.string().required("This field is Required"),
    expiry_date: Yup.string().required("This field is Required"),
    is_reminder: Yup.boolean(),
    reminder_date: Yup.string().when("is_reminder", {
      is: true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    // file: Yup.mixed()
    // .when("is_reminder", {
    // is: true,
    // then: (schema) =>
    // schema
    // .required("At least one file is required")
    // .test("file-required", "At least one file is required", (value) => {
    //   return value && value.length > 0;
    // }),
    // otherwise: (schema) => schema.notRequired(),
    // }),
  }),
  addEditDocTypeSchema: Yup.object().shape({
    name: Yup.string().trim().required("This field is Required"),
  }),

  addMasterLocationSchema: Yup.object().shape({
    name: Yup.string().trim().required("Attention is Required"),

    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email address")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }), // Validat

    gst_treatment_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),

    gst_no: Yup.string().when("gst_treatment_id", {
      is: (value) => value?.value != 1, // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // GST number is not required when value is 1
    }),
  }),
  newEwayDetailsSchema: Yup.object().shape({
    consignor_id: Yup.object().shape({
      label: Yup.string().required("Party name is required"),
    }),
    consignor_location: Yup.object().shape({
      label: Yup.string().required("Party name is required"),
    }),
  }),


  addMakeSupplierTripPaymSchema: Yup.object().shape({
    sub_category: Yup.string().required("This field is Required"),
    txn_date: Yup.string().required("This field is Required"),
    account_sub_category: Yup.string().required("This field is Required"),
    account_id: Yup.string().required("This field is Required"),
  }),

  tdsDeductionInvoiceSchema: Yup.object().shape({
    // amount: Yup.string().required("This field is Required"),
    tds_percentage: Yup.object().shape({
      label: Yup.string().required("This field is Required"),
    }),
  }),

  addMarketDriver: Yup.object().shape({
    driver_id: Yup.string().required("This field is Required")
  }),

  addEditCategoryParts: Yup.object().shape({
    name: Yup.string().trim().required("This filed is Required"),
    hsn_code: Yup.string().trim().required("This filed is Required"),
    gst_rate: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    account_to_reflect: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    unit: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    odometer_reading: Yup.boolean(),
    odometer_kms: Yup.string().when("odometer_reading", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    time_interval: Yup.boolean(),
    time_interval_days: Yup.string().when("time_interval", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
  addEditManufacturerSchema: Yup.object().shape({
    name: Yup.string().trim().required("This field is Required"),
    category_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
  }),
  addEditItems1: Yup.object().shape({
    type: Yup.boolean(),
    part_category_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    manufacture_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    category_number: Yup.string().trim().required("This filed is Required"),
    // hsn_code: Yup.string().trim().required("This filed is Required"),
    // manufacture_id: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    // code: Yup.string().trim().required("This filed is Required"),
    // gst_rate: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    inventory: Yup.boolean(),
    stock_in_hand: Yup.string().when("inventory", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    rate: Yup.string().when("inventory", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    amount: Yup.string().when("inventory", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    open_kms: Yup.string().when("inventory", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    total_kms: Yup.string().when("inventory", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    account_to_reflect: Yup.object().when("inventory", {
      is: (test) => test === true,
      then: (schema) => schema.shape({
        label: Yup.string().required("This field is required"),
      }),
      otherwise: (schema) => schema.notRequired(),
    }),
    // type_unit: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    odometer_reading: Yup.boolean(),
    odometer_kms: Yup.string().when("odometer_reading", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    time_interval: Yup.boolean(),
    time_interval_days: Yup.string().when("time_interval", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),
  addEditItems2: Yup.object().shape({
    name: Yup.string().trim().required("This filed is Required"),
    // code: Yup.string().trim().required("This filed is Required"),
    // hsn_code: Yup.string().trim().required("This filed is Required"),
    // gst_rate: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    // account_to_reflect: Yup.object().shape({
    //   label: Yup.string().required("This filed is Required"),
    // }),
    odometer_reading: Yup.boolean(),
    odometer_kms: Yup.string().when("odometer_reading", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    time_interval: Yup.boolean(),
    time_interval_days: Yup.string().when("time_interval", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),

  addCategoryType: Yup.object().shape({
    name: Yup.string().trim().required("This field is Required"),
    calculation_type: Yup.number().required("This field is Required"),
  }),

  addEditServiceRemainderSchema: Yup.object().shape({
    vehicle_id: Yup.object().shape({
      name: Yup.string().required("This filed is Required"),
    }),
    odometer: Yup.string().trim().required("This field is Required"),
    item_id: Yup.object().shape({
      label: Yup.string().required("This filed is Required"),
    }),
    reminder_date: Yup.string().trim().required("This field is Required"),
    reminder_kms: Yup.string().trim().required("This field is Required"),
  }),
  markRemainderSchema: Yup.object().shape({
    schedule_next_service: Yup.boolean(),
    reminder_date: Yup.string().when("schedule_next_service", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    reminder_kms: Yup.string().when("schedule_next_service", {
      is: (test) => test === true,
      then: (schema) => schema.required("This field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    odometer: Yup.string().trim().required("This field is Required"),
    complete_date: Yup.string().trim().required("This field is Required"),
  }),

  addMakeAmountServiceSchema: Yup.object().shape({
    due_amount: Yup.number()
      .typeError("Amount must be a valid number")
      .required("Amount is required")
      .test("not-zero", "Amount must be greater than 0", (value) => Number(value) > 0)
      .test(
        "amount-not-greater-than-due-balance",
        "Amount cannot exceed the remaining due balance.",
        function (value) {
          const dueBalance = this.parent.due_balance;
          return Number(value) <= Number(dueBalance);
        }
      ),

    date: Yup.string().required("This field is Required"),
    account_sub_category: Yup.string().required("This field is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "10" && val != "11",
      then: () => Yup.string().required("This field is Required"),
    }),
    isCheck: Yup.boolean(),
    vendor_bank_account: Yup.string().when("isCheck", {
      is: (test) => test === true,
      then: () => Yup.string().required("This field is Required"),
    }),
  }),

  addMakeAmountExpenseSchema: Yup.object().shape({

    dueBalance: Yup.number()
      .required("Balance is required")
      .positive("Balance must be a positive number"),
    due_amount: Yup.number()
      .required("Amount is required")
      .positive("Amount must be a positive number")
      .transform((value, originalValue) => {
        if (originalValue === "") {
          return null;
        }
        return value;
      })
      .when("dueBalance", (dueBalance, schema) =>
        schema.test({
          test: function (value) {
            return value <= dueBalance;
          },
          message: "Amount must not be greater than balance",
        })
      ),

    date: Yup.string().required("This field is Required"),
    account_sub_category: Yup.string().required("This field is Required"),
    account_id: Yup.string().when("account_sub_category", {
      is: (val) => val != "10" && val != "11",
      then: () => Yup.string().required("This field is Required"),
    }),
    isCheck: Yup.boolean(),
    vendor_bank_account: Yup.string().when("isCheck", {
      is: (test) => test === true,
      then: () => Yup.string().required("This field is Required"),
    }),

    vendor_id: Yup.string().when("account_sub_category", {
      is: (val) => val == "11",
      then: () => Yup.string().required("This field is Required"),
      // otherwise: () => Yup.string().notRequired(),
    }),

  }),

  addFirmSchema: Yup.object().shape({
    firm: Yup.string().required("This field is required"),
    entity_type: Yup.string().required("Entity Type is Required"),
    address_line1: Yup.string().required("This field is required"),
    email_id: Yup.string()
      .nullable() // Allows empty values
      .notRequired() // Makes the field optional
      .email("Invalid email format. Example: example@domain.com")
      .test("tld-check", "Top-level domain cannot contain numbers", (value) => {
        if (!value) return true; // Skip validation if the field is empty
        const domain = value.split("@")[1]; // Extract domain part after "@"
        if (!domain) return false; // Ensure domain exists
        const tld = domain.split(".").pop(); // Extract the top-level domain (after the last ".")
        return !/\d/.test(tld); // Ensure the top-level domain does not contain digits
      }),
    alt_contact_no: Yup.string()
      .nullable()
      .notRequired() // Makes the field optional
      .test(
        "is-valid-mobile",
        "Enter a valid alternative mobile number",
        (value) => {
          if (!value) return true; // Skip validation if empty
          return mobileFormateRehex.test(value); // Validate only if a value exists
        }
      ),
    contact_no: Yup.string()
      .nullable()
      .required("This field is required") // Makes the field optional
      .test("is-valid-mobile", "Enter a valid mobile number", (value) => {
        if (!value) return true; // Skip validation if empty
        return mobileFormateRehex.test(value); // Validate only if a value exists
      }),
    // contact_no: Yup.string().required("Contact Number is Required"),
    gst_type: Yup.object({
      label: Yup.string().required("This field is required"),
    }),
    gst_no: Yup.string().when("gst_type", {
      is: (test) => (test?.value == 2) || (test?.value == 3), // Validation will apply when the checkbox is true
      then: () =>
        Yup.string()
          .required("GST number is required")
          .matches(gstFormateRegex, "Invalid GST format")
          .min(15, "GST number must be 15 characters long") // Ensures the GST number length is 15
          .max(15, "GST number must be 15 characters long"), // Ensures the GST number length is 15
    }),
    city: Yup.object({
      label: Yup.string().required("This field is required"),
    }),
  }),

  interFirmFreigthSchema: Yup.object().shape({
    sub_category: Yup.string().required("This field is Required"),

    balance: Yup.number()
      .required("Balance is required"),
    // .positive("Balance must be a positive number"),

    amount: Yup.number()
      .transform((value, originalValue) => {
        if (originalValue === "") return null;
        return value;
      })
      .when(["sub_category", "balance"], {
        is: (sub_category, balance) =>
          sub_category == 2 && (balance === 0 || checkBalance(balance) === "minus"),
        then: (schema) => schema.notRequired(), // skip validation
        otherwise: (schema) =>
          schema
            .required("Amount is required")
            .positive("Amount must be a positive number")
            .test("amount-less-than-balance", "Amount must not be greater than balance", function (value) {
              const { balance } = this.parent;
              return value <= balance;
            }),
      }),

    txn_date: Yup.string().required("This field is Required"),

    account_sub_category: Yup.string().required("This field is Required"),
    to_account_sub_category: Yup.string().required("This field is Required"),
    account_id: Yup.string().required("This field is Required"),
    to_account_id: Yup.string().required("This field is Required"),
    // isCheck: Yup.boolean(),

    // vendor_account: Yup.string().when("isCheck", {
    //   is: true,
    //   then: () => Yup.string().required("This field is Required"),
    // }),
  }),

  addEditFirmBankSchema: Yup.object().shape({
    account_number: Yup.string().required("Account Number is required"),
    bank_name: Yup.string().required("Account Name is required"),
    ifsc_code: Yup.string()
      .test(
        "valid-ifsc",
        "Invalid IFSC code format",
        (value) =>
          !value || /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)
      ).required("IFSC code is required"),
  }),
  addFuelStationFundTransSchema: Yup.object().shape({

    balance: Yup.number(),
    // .positive("Balance must be a positive number"),

    due_amount: Yup.number()
      .transform((value, originalValue) => {
        if (originalValue === "") return null;
        return value;
      })
      .when(["sub_category", "balance"], {
        is: (sub_category, balance) =>
          sub_category == 2 ||  // ✅ sub_category 1 pe hamesha skip
          (balance === 0 || checkBalance(balance) === "minus"),
        then: (schema) => schema.notRequired(),
        otherwise: (schema) =>
          schema
            .required("Amount is required")
            .positive("Amount must be a positive number")
            .test("amount-less-than-balance", "Amount must not be greater than balance", function (value) {
              const { balance } = this.parent;
              return value <= balance;
            }),
      }),

    date: Yup.string().when("sub_type", {
      is: 2,
      then: () => Yup.string().required("This field is Required"),
    }),

    account_sub_category: Yup.string().when("sub_type", {
      is: 2,
      then: () => Yup.string().required("This field is Required"),
    }),

    account_id: Yup.string().when(["account_sub_category", "sub_type"], {
      is: (val, sub_type) => sub_type === 2 && val != "10" && val != "11",
      then: () => Yup.string().required("This field is Required"),
    }),

    isCheck: Yup.boolean(),

    vendor_bank_account: Yup.string().when(["isCheck"], {
      is: (isCheck) => isCheck === true,
      then: () => Yup.string().required("This field is Required"),
    }),

  })
};

export const fueloutTripSchema = (availableFuel) =>
  Yup.object().shape({
    fuel_out_time: Yup.string().required("This field is required"),
    fuel_ltr: Yup.string()
      .typeError("Fuel (ltr) must be a number")
      .required("This field is required")
      .test(
        "max-fuel",
        `Fuel (ltr) cannot be more than available fuel (${availableFuel})`,
        function (value) {
          return value <= availableFuel;
        }
      ),
    fuel_amount: Yup.string().required("This field is required"),
  });

export const gstDetailsSchema = Yup.object().shape({
  gst_number: Yup.string().when('$hasGST', {
    is: true,
    then: (schema) =>
      schema
        .required("GST number is required")
        .matches(gstRegex, "Invalid GST format")
        .length(15, "GST number must be exactly 15 characters"),
    otherwise: (schema) => schema.nullable()
  }),
  company_name: Yup.string()
    .required("Company name is required")
    .min(2, "Company name must be at least 2 characters"),
  email_address: Yup.string()
    .required("Email address is required")
    .matches(emailRegex, "Please enter a valid email address")
})

export const billingAddressSchema = Yup.object().shape({
  address: Yup.string()
    .required("Address is required"),

  city: Yup.string()
    .required("City is required")
    .min(2, "City name must be at least 2 characters"),
  state: Yup.string()
    .required("State is required")
    .min(2, "State name must be at least 2 characters"),
  pin_code: Yup.string()
    .required("PIN code is required")
    .matches(pinCodeRegex, "Invalid PIN code format")
    .length(6, "PIN code must be exactly 6 digits")
})

export const subscriptionFormSchema = Yup.object().shape({
  gst_details: gstDetailsSchema,
  billing_address: billingAddressSchema
})


export const addAssociationSchema = Yup.object().shape({
  from_firm_id: Yup.string()
    .required("Please select from firm"),

  to_firm_id: Yup.string()
    .required("Please select to firm"),

  pay_type: Yup.string()
    .required("Please select payment type"),

  opening_balance: Yup.string()
    .required("Please enter opening balance")
    .matches(/^\d*\.?\d*$/, "Please enter valid amount")
    .test('is-greater-than-zero', 'Amount must be greater than zero', function (value) {
      if (!value) return false;
      return parseFloat(value) > 0;
    }),


});